import React, {ChangeEvent} from 'react';
import {FormControl, InputLabel, MenuItem, Select, Stack, TextField} from '@mui/material';
import styles from './TransactionsComponent.module.css';
import {TransactionFiltersResponse, TransactionRequest} from "../../api/TransactionApi";
import {getStatusLabel} from './statusLabels';

interface TransactionFilterProps {
    filters: TransactionFiltersResponse | undefined;
    request: TransactionRequest;
    onFilterChange: (key: keyof TransactionRequest) => (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any) => void;
}

const sampleAmounts = [100, 500, 1000, 5000];


const TransactionFilters: React.FC<TransactionFilterProps> = ({
                                                                       filters,
                                                                       request,
                                                                       onFilterChange
                                                                   }) => {
    return (
        <Stack className={styles.filtersContainer}>
            <TextField
                label="Search"
                value={request.search ?? ''}
                placeholder="Search..."
                onChange={onFilterChange('search')}
                slotProps={{inputLabel: {shrink: true}}}
                className={styles.searchField}
            />
            <FormControl className={styles.merchantSelect}>
                <InputLabel>Merchant</InputLabel>
                <Select
                    label="Merchant account"
                    value={request.merchantId ?? ''}
                    onChange={onFilterChange('merchantId')}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.merchantId.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={styles.currencySelect}>
                <InputLabel>Currency</InputLabel>
                <Select
                    label="Currency"
                    value={request.currency ?? ''}
                    onChange={onFilterChange('currency')}
                    MenuProps={{
                        PaperProps: {
                            className: styles.currencyMenu,
                        },
                    }}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.transactionCurrency.map(c => (
                        <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                type="date"
                label="From"
                value={request.transactionDateFrom ?? ''}
                onChange={onFilterChange('transactionDateFrom')}
                slotProps={{inputLabel: {shrink: true}}}
            />
            <TextField
                type="date"
                label="To"
                value={request.transactionDateTo ?? ''}
                onChange={onFilterChange('transactionDateTo')}
                slotProps={{inputLabel: {shrink: true}}}
            />
            <FormControl className={styles.statusSelect}>
                <InputLabel>Status</InputLabel>
                <Select
                    label="Status"
                    value={request.status ?? ''}
                    onChange={onFilterChange('status')}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.status.map(s => (
                        <MenuItem key={s} value={s}>{getStatusLabel(s)}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={styles.statusSelect}>
                <InputLabel>Amount Min</InputLabel>
                <Select
                    label="Amount Min"
                    value={request.totalAmountMin ?? ''}
                    onChange={onFilterChange('totalAmountMin')}
                >
                    <MenuItem value="">All</MenuItem>
                    {sampleAmounts.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={styles.statusSelect}>
                <InputLabel>Amount Max</InputLabel>
                <Select
                    label="Amount Max"
                    value={request.totalAmountMax ?? ''}
                    onChange={onFilterChange('totalAmountMax')}
                >
                    <MenuItem value="">All</MenuItem>
                    {sampleAmounts.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};

export default TransactionFilters;